var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.19 33.5403L64.9713 21.2356L63.2812 20.6641V4.53125H16.875V20.6641L15.0287 21.2356L0.81 33.5403C0.295625 33.9855 0 34.6322 0 35.3125V77.6562C0 78.9506 1.04937 80 2.34375 80H77.6562C78.9506 80 80 78.9506 80 77.6562V35.3125C80 34.6322 79.7044 33.9855 79.19 33.5403Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 28.2812C38.7077 28.2812 37.6562 29.3327 37.6562 30.625C37.6562 31.9173 38.7077 32.9688 40 32.9688C41.2923 32.9688 42.3438 31.9173 42.3438 30.625C42.3438 29.3327 41.2923 28.2812 40 28.2812ZM63.4375 0H16.5625C15.2688 0 14.2188 1.05 14.2188 2.34375V48.8234L38.4562 70.0453C38.8984 70.4313 39.4484 70.625 40 70.625C40.5516 70.625 41.1016 70.4313 41.5438 70.0453L65.7812 48.825V2.34375C65.7812 1.05 64.7313 0 63.4375 0ZM49.375 37.6562C47.5755 37.6562 45.9325 36.9759 44.6875 35.8602C43.4425 36.9759 41.7995 37.6562 40 37.6562C36.123 37.6562 32.9688 34.502 32.9688 30.625C32.9688 26.748 36.123 23.5938 40 23.5938C43.877 23.5938 47.0312 26.748 47.0312 30.625C47.0312 31.9173 48.0827 32.9688 49.375 32.9688C50.6673 32.9688 51.7188 31.9173 51.7188 30.625C51.7188 24.1633 46.4617 18.9062 40 18.9062C33.5383 18.9062 28.2812 24.1633 28.2812 30.625C28.2812 37.0867 33.5383 42.3438 40 42.3438C41.3427 42.3438 42.6581 42.1192 43.91 41.6764C45.13 41.2445 46.4694 41.8839 46.9012 43.1042C47.333 44.3245 46.6936 45.6637 45.4733 46.0955C43.7181 46.7164 41.8766 47.0312 40 47.0312C30.9536 47.0312 23.5938 39.6714 23.5938 30.625C23.5938 21.5786 30.9536 14.2188 40 14.2188C49.0464 14.2188 56.4062 21.5786 56.4062 30.625C56.4062 34.502 53.252 37.6562 49.375 37.6562Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40,
    y1: 80,
    x2: 40,
    y2: 4.53125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3A84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 40,
    y1: 70.625,
    x2: 40,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoEmail);
export default __webpack_public_path__ + "static/media/picto_email.145e99c37aa7a6ef4897d124cbeb185e.svg";
export { ForwardRef as ReactComponent };